module.exports = __webpack_public_path__ + "logos/logo-fullstory.39d007.svg";